import { FC } from 'react';

import Button, { ButtonAppearance } from 'bloko/blocks/button';
import ClickMenu, { MenuPlacement } from 'bloko/blocks/drop/Menu/Click';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';
import Loading, { LoadingScale } from 'bloko/blocks/loading';

import MenuItems from 'components/CampaignAdminActions/MenuItems';

import { FrontendStatusType } from 'store/models/dashboard';
import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

import 'components/CampaignAdminActions/CampaignAdminActions.less';

interface CampaignAdminActionsProps {
    campaignId: number;
    frontendStatus: FrontendStatusType;
}

const CampaignAdminActions: FC<CampaignAdminActionsProps> = ({ campaignId, frontendStatus }) => {
    const sessionType = useSelector((state) => state.user.sessionType);
    const { campaignId: campaignIdForAdmin, isLoad } = useSelector((state) => state.adminCampaignAction);

    if (sessionType !== SessionType.Sudo) {
        return null;
    }
    return (
        <div className="campaign-admin-actions">
            <ClickMenu
                render={(close) => <MenuItems campaignId={campaignId} close={close} frontendStatus={frontendStatus} />}
                placement={MenuPlacement.BottomEnd}
            >
                <Button
                    appearance={ButtonAppearance.Outlined}
                    loading={
                        isLoad && campaignIdForAdmin === campaignId ? <Loading scale={LoadingScale.Small} /> : null
                    }
                    icon={<Icon view={IconView.Bars} initial={IconColor.Gray60} scale={IconScale.Small} />}
                />
            </ClickMenu>
        </div>
    );
};

export default CampaignAdminActions;
